import PropTypes from "prop-types";
import { Chip, Stack, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";

const TabLabel = ({ name, count }) => (
  <Stack direction="row" alignItems="center" spacing={0.75}>
    <span>{name}</span>
    <Chip
      label={count}
      size="small"
      sx={{
        height: 18,
        fontSize: "0.65rem",
        fontWeight: 600,
        "& .MuiChip-label": { px: 0.75 },
      }}
    />
  </Stack>
);

export const ResultTabs = ({ tabs, activeTab, onChange, counts, totalCount }) => {
  const { t } = useTranslation();

  return (
    <Tabs
      value={activeTab}
      onChange={(_, newValue) => onChange(newValue)}
      variant="scrollable"
      scrollButtons="auto"
      sx={{ mt: 2, borderBottom: 1, borderColor: "divider" }}
    >
      {tabs.map((tab, index) => {
        const isAll = tab === "All";
        const name = isAll
          ? t("search.types.all")
          : t(`search.types.${tab}`, { defaultValue: tab });
        const count = isAll ? (totalCount ?? 0) : (counts?.[tab] ?? 0);
        return (
          <Tab
            key={tab}
            label={<TabLabel name={name} count={count} />}
            value={index}
          />
        );
      })}
    </Tabs>
  );
};

ResultTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeTab: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  counts: PropTypes.object,
  totalCount: PropTypes.number,
};